module.exports = __webpack_public_path__ + "media/images/countryrect/cx-b01688bcb3d430127c7c4f70d69022f3.svg";